<template>
  <div class="card-light">
    <div class="flex flex-col items-center gap-4 text-center md:flex-row md:text-left">
      <SvgPictoCoupons class="mx-auto size-16 shrink-0 sm:mx-0" />
      <h3 class="h3 md:mr-auto">
        Vous avez un code promotionnel ou une carte cadeau?
      </h3>
      <CartApplyCouponForm class="mx-auto sm:mx-0" />
    </div>
  </div>
</template>
